export default "__VITE_ASSET__CDiG9gwn__"